<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div *ngIf="!isAddForm" class="row my-4">
		<div class="col-12 col-lg">
			<label for="statut" class="form-label fw-bold"
				>Statut</label
			>
			<select
				required
				*ngIf="!this.isAddForm"
				id="statut"
				class="form-select"
				name="statut"
				formControlName="statut"
				aria-label="Sélectionner un statut"
				[ngClass]="{
					'is-invalid': statut.invalid,
					'is-valid': statut.dirty && statut.valid
				}"
			>
				<option [value]="PrestationStatutEnum.OUVERT">Ouvert</option>
				<option [value]="PrestationStatutEnum.COURS">En cours</option>
				<option [value]="PrestationStatutEnum.ANNULE">Annulé</option>
				<option [value]="PrestationStatutEnum.CLOT">Clôturé</option>
			</select>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('numeroCommande')" class="col-12 col-lg">
			<label for="numeroCommande" class="form-label fw-bold"
				>N° de commande</label
			>
			<input
				id="numeroCommande"
				class="form-control"
				formControlName="numeroCommande"
			/>
		</div>
	</div>
	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="canalCommunication" class="form-label fw-bold"
				>Canal de communication</label
			>
			<select
				id="canalCommunication"
				class="form-select"
				name="canalCommunication"
				formControlName="canalCommunication"
				aria-label="Sélectionner un canal"
				>
				<option *ngFor="let canalCommunication of listCanalCommunication" value="{{ canalCommunication.id }}">
					{{ canalCommunication.name}}
				</option>
			</select>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Identification de la demande</span>
	</div>

	<div *ngIf="form.contains('numeroDemande')" class="col-12 col-lg">
		<label for="eeNomEntreprise" class="form-label fw-bold"
			>Numéro de la demande</label
		>
		<input
			id="eeNomEntreprise"
			class="form-control"
			formControlName="eeNomEntreprise"
		/>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dateDebut')" class="col-12 col-lg">
			<label for="dateDebut" class="form-label fw-bold"
				>Date de reception de la demande</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateDebut"
				name="dateDebut"
				formControlName="dateDebut"
				[ngClass]="{
					'is-invalid': dateDebut.invalid,
					'is-valid': dateDebut.dirty && dateDebut.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('dateAr')" class="col-12 col-lg">
			<label for="dateAr" class="form-label fw-bold"
				>Date de l'AR</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateAr"
				name="dateAr"
				formControlName="dateAr"
				[ngClass]="{
					'is-invalid': dateAr.invalid,
					'is-valid': dateAr.dirty && dateAr.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dateFin')" class="col-12 col-lg">
			<label for="dateFin" class="form-label fw-bold"
				>Date de fin (envoi d'une fiche de synthèse)</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateFin"
				name="dateFin"
				formControlName="dateFin"
				[ngClass]="{
					'is-invalid': dateFin.invalid,
					'is-valid': dateFin.dirty && dateFin.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-5" *ngIf="false">
		<div class="d-flex justify-content-end">
			<button
				[disabled]="this.disableChooseEmployeeButton()"
				class="btn theme-green-button"
				type="button"
				(click)="openModalChooseEmployee()"
				>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Choisir un intervenant
			</button>
		</div>
	</div>
	<!--<app-prestation-modal-choose-intervenant *ngIf="showModal"
					[selectedAddress]="selectedAddress"
					[selectedExpertises]="selectedExpertises"
					(sendForm)="submitForm()"
					(hideModal)="bsModalRef.hide()"
					[isValidateButtonClicked]="isValidateButtonClicked"
	></app-prestation-modal-choose-intervenant>-->

	<div class="row my-4">
		<div class="col-12">
			<label for="prescripteur" class="form-label fw-bold"
				>Prescripteur</label
			>
			<select
				id="prescripteur"
				class="form-select"
				name="prescripteur"
				formControlName="prescripteur"
				aria-label="Sélectionner un prescripteur"
				>
				<option *ngFor="let prescripteur of listPrescripteur" value="{{ prescripteur.id }}">
					{{ prescripteur.nomStructure}}
				</option>
			</select>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Bénéficiaire</span>
	</div>

	<div class="row my-4">
		<!-- <div class="col-12 col-lg">
			<label for="beneficiaire" class="form-label fw-bold"
				>Bénéficiaire</label
			>
			<select
				id="beneficiaire"
				class="form-select"
				name="beneficiaire"
				formControlName="beneficiaire"
				aria-label="Sélectionner un bénéficiaire"
				>
				<option *ngFor="let beneficiaire of listBeneficiaire" value="{{ beneficiaire.id }}">
					{{ beneficiaire.firstName + ' ' +beneficiaire.lastName}}
				</option>
			</select>
		</div> -->
		<div class="col-12 col-lg">
			<label for="statutBeneficiaire" class="form-label fw-bold"
				>Statut de bénéficiaire</label
			>
			<select
				id="statutBeneficiaire"
				class="form-select"
				name="statutBeneficiaire"
				formControlName="statutBeneficiaire"
				aria-label="Sélectionner un type"
				(change)="onStatutBeneficiciareChanged()"
			>
				<!-- <option [value]="StatutBeneficiaireEnum.DE">Demandeur d'emploi</option> -->
				<option [value]="StatutBeneficiaireEnum.EEPRIV">En emploi public</option>
				<option [value]="StatutBeneficiaireEnum.EEPRIV">En emploi privé</option>
				<option [value]="StatutBeneficiaireEnum.EF">Vers l'emploi</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeHandicap" class="form-label fw-bold">Typologie de handicap</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let typeHandicap of listTypeHandicap | orderBy : 'name' : 'asc'"
				>
				<div *ngIf="typeHandicap.id !== 0">
					<input
						type="checkbox"
						name="{{ typeHandicap.id }}"
						class="form-check-input"
						[value]="typeHandicap"
						[checked]="isTypeHandicapCheck(typeHandicap)"
						[ngClass]="{
							'theme-main-color-check': isTypeHandicapCheck(typeHandicap)
						}"
						(change)="updateSelectedTypeHandicap($event, typeHandicap)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ typeHandicap.name }}
					</label>
				</div>
			</div>
			</div>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Question - Réponse</span>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('demandePrescripteur')" class="col-12 col-lg">
			<label for="demandePrescripteur" class="form-label fw-bold"
				>Demande du prescripteur</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDemandePrescripteur"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDemandePrescripteur" formControlName="demandePrescripteur"></ngx-editor>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('reponseDemande')" class="col-12 col-lg">
			<label for="reponseDemande" class="form-label fw-bold"
				>Réponse à la demande</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorReponseDemande"> </ngx-editor-menu>
				<ngx-editor [editor]="editorReponseDemande" formControlName="reponseDemande"></ngx-editor>
			</div>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Typologie de la demande</span>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<!-- <label for="typeDemande" class="form-label fw-bold"
				>Type</label
			> -->
			<select
				id="typologieDemande"
				class="form-select"
				name="typologieDemande"
				formControlName="typologieDemande"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': typologieDemande.invalid,
					'is-valid': typologieDemande.dirty && typologieDemande.valid
				}"
				(change)="onTypologieDemandeChanged()"
			>
				<option [value]="TypologieDemandeEnum.HI">Hors INFOSAS</option>
				<option [value]="TypologieDemandeEnum.OS">Offre de service en général</option>
				<option [value]="TypologieDemandeEnum.DA">Demande administrative</option>
				<option [value]="TypologieDemandeEnum.BO">Bonne orientation</option>
				<option [value]="TypologieDemandeEnum.DSB">Demande en fonction de la situation du bénéficiaire</option>
			</select>
		</div>
	</div>

	<div *ngIf="this.isHISelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="motifRefus" class="form-label fw-bold"
				>Motif refus</label
			>
			<select
				id="motifRefus"
				class="form-select"
				name="motifRefus"
				formControlName="motifRefus"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': motifRefus.invalid,
					'is-valid': motifRefus.dirty && motifRefus.valid
				}"
			>
				<option [value]="MotifRefusEnum.I">Sensibilisation générale au handicap</option>
				<option [value]="MotifRefusEnum.II">Canal de communication sur les appuis spécifiques</option>
				<option [value]="MotifRefusEnum.III">Demande de renseignement dans le cadre d'un suivi de dossier</option>
				<option [value]="MotifRefusEnum.IV">Quelques techniques relatives à la plateforme digitale</option>

			</select>
		</div>
	</div>

	<div *ngIf="this.isDASelected" class="row my-4">
		<div class="col-12 col-lg">
			<!-- <label for="situationGeographique" class="form-label fw-bold"
				>Motif refus</label
			> -->
			<select
				id="situationGeographique"
				class="form-select"
				name="situationGeographique"
				formControlName="situationGeographique"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': situationGeographique.invalid,
					'is-valid': situationGeographique.dirty && situationGeographique.valid
				}"
			>
				<option [value]="DemandeAdministrativeEnum.SG">Situation géographique</option>
				<option [value]="DemandeAdministrativeEnum.SB">Situation bénéficiaire</option>

			</select>
		</div>
	</div>

	<div *ngIf="this.isBOSelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeHandicap" class="form-label fw-bold"
				>Type de handicap</label
			>
			<select
				id="typeHandicap"
				class="form-select"
				name="typeHandicap"
				formControlName="typeHandicap"
				aria-label="Sélectionner un type"
				>
				<option *ngFor="let typeHandicap of listTypeHandicap" value="{{ typeHandicap.id }}">
					{{ typeHandicap.name}}
				</option>
			</select>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutDESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('deProjetPro')" class="col-12 col-lg">
			<label for="deProjetPro" class="form-label fw-bold"
				>Y a-t-il un projet professionnel ? Si oui quelles sont les questions qui se posent au regard du projet professionnel ?</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDeProjetPro"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDeProjetPro" formControlName="deProjetPro"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutDESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('deContraintesHandicap')" class="col-12 col-lg">
			<label for="deContraintesHandicap" class="form-label fw-bold"
				>Les contraintes de handicap sont-elles identifiées ?</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDeContraintesHandicap"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDeContraintesHandicap" formControlName="deContraintesHandicap"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutDESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('deDispositifs')" class="col-12 col-lg">
			<label for="deDispositifs" class="form-label fw-bold"
				>Quels sont les dispositifs/accompagnements préalablement mobilisés ?</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDeDispositifs"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDeDispositifs" formControlName="deDispositifs"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutDESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('deRuptureParcours')" class="col-12 col-lg">
			<label for="deRuptureParcours" class="form-label fw-bold"
				>Y a-t-il des ruptures de parcours ?</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDeRuptureParcours"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDeRuptureParcours" formControlName="deRuptureParcours"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutDESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('deBesoinsIdent')" class="col-12 col-lg">
			<label for="deBesoinsIdent" class="form-label fw-bold"
				>Y a-t-il des besoins déjà identifiés ?</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDeBesoinsIdent"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDeBesoinsIdent" formControlName="deBesoinsIdent"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('eeLimites')" class="col-12 col-lg">
			<label for="eeLimites" class="form-label fw-bold"
				>Quelles sont les limites et capacités de la personne dans le cadre de l'emploi</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEeLimites"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEeLimites" formControlName="eeLimites"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('eeQuestEmploi')" class="col-12 col-lg">
			<label for="eeQuestEmploi" class="form-label fw-bold"
				>Quelles sont les questions qui se posent au regard de 
				l'emploi en lien avec la situation de handicap de la personne</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEeQuestEmploi"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEeQuestEmploi" formControlName="eeQuestEmploi"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('eeBesoinsAdapt')" class="col-12 col-lg">
			<label for="eeBesoinsAdapt" class="form-label fw-bold"
				>Y a-t-il un besoin d'adaptation globale de l'environnement de travail</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEeBesoinsAdapt"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEeBesoinsAdapt" formControlName="eeBesoinsAdapt"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('eePbAccess')" class="col-12 col-lg">
			<label for="eePbAccess" class="form-label fw-bold"
				>Y a-t-il un problème d'accessibilité au sein de l'entreprise</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEePbAccess"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEePbAccess" formControlName="eePbAccess"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEESelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('eeAccompDejaMene')" class="col-12 col-lg">
			<label for="eeAccompDejaMene" class="form-label fw-bold"
				>Quelles sont les actions d’accompagnement déjà menées et quels sont les besoins liés au handicap qui ont émergé</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEeAccompDejaMene"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEeAccompDejaMene" formControlName="eeAccompDejaMene"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEFSelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('efLimiteCapacite')" class="col-12 col-lg">
			<label for="efLimiteCapacite" class="form-label fw-bold"
				>Quellles sont les limites et capacités de la personne dans le cadre
				de l'emploi</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEfLimiteCapacite"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEfLimiteCapacite" formControlName="efLimiteCapacite"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEFSelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('efQuestionnement')" class="col-12 col-lg">
			<label for="efQuestionnement" class="form-label fw-bold"
				>Quelles sont les questions qui se posent au regard de la formation
				en lien avec la situation de handicap de la personne </label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEfQuestionnement"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEfQuestionnement" formControlName="efQuestionnement"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEFSelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('efAccessibilite')" class="col-12 col-lg">
			<label for="efAccessibilite" class="form-label fw-bold"
				>Y a-t-il un besoin en termes d'accessibilité et/ou de compensation</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEfAccessibilite"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEfAccessibilite" formControlName="efAccessibilite"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEFSelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('typeFormation')" class="col-12 col-lg">
			<label for="typeFormation" class="form-label fw-bold"
				>Type de formation</label
			>
			<select
				id="typeFormation"
				class="form-select"
				name="typeFormation"
				formControlName="typeFormation"
				>
				<option *ngFor="let typeFormation of listTypeFormation" value="{{ typeFormation.id }}">
					{{ typeFormation.name}}
				</option>
			</select>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected && this.isStatutEFSelected && !this.isAssistant" class="row my-4">
		<div *ngIf="form.contains('efBesoinsAt')" class="col-12 col-lg">
			<label for="efBesoinsAt" class="form-label fw-bold"
				>Y a-t-il des besoins en aides techniques/numériques ? Sont-elles identifiées ?</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorEfBesoinsAt"> </ngx-editor-menu>
				<ngx-editor [editor]="editorEfBesoinsAt" formControlName="efBesoinsAt"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected || this.isOSSelected || this.isDASelected || this.isBOSelected" class="row">
		<span class="theme-main-color fs-4 col">Conclusions</span>
	</div>

	<div *ngIf="this.isDSBSelected || this.isOSSelected || this.isDASelected || this.isBOSelected" class="row my-4">
		<div
			*ngIf="form.contains('reorientation')"
			class="form-check form-switch ms-2"
		>
			<input
				class="form-check-input theme-main-border-color"
				type="checkbox"
				id="reorientation"
				formControlName="reorientation"
				[ngClass]="{
					'theme-main-color-check': reorientation.value
				}"
				(change)="onReorientationChanged($event)"
			/>
			<label class="form-check-label text-dark" for="reorientation"
				>Réorientation vers un autre dispositif</label
			>
		</div>
	</div>

	<div *ngIf="this.isReorientationNewPresta && (this.isDSBSelected || this.isOSSelected || this.isDASelected || this.isBOSelected)" class="row my-4">
		<div *ngIf="form.contains('organismeReorientation')" class="col-12 col-lg">
			<label for="organismeReorientation" class="form-label fw-bold"
				>Organisme de réorientation</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="organismeReorientation"
				name="organismeReorientation"
				formControlName="organismeReorientation"
				[ngClass]="{
					'is-invalid': organismeReorientation.invalid,
					'is-valid': organismeReorientation.dirty && organismeReorientation.valid
				}"
			/>
		</div>
	</div>

	<div *ngIf="this.isReorientationNewPresta && (this.isDSBSelected || this.isOSSelected || this.isDASelected || this.isBOSelected)" class="row my-4">
		<div *ngIf="form.contains('contactReorientation')" class="col-12 col-lg">
			<label for="contactReorientation" class="form-label fw-bold"
				>Contact organisme de réorientation</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="contactReorientation"
				name="contactReorientation"
				formControlName="contactReorientation"
				[ngClass]="{
					'is-invalid': contactReorientation.invalid,
					'is-valid': contactReorientation.dirty && contactReorientation.valid
				}"
			/>
		</div>
	</div>

	<div *ngIf="!this.isReorientationNewPresta && (this.isDSBSelected || this.isOSSelected || this.isDASelected || this.isBOSelected) && !this.isAssistant" class="row my-4">
		<div class="col-12 col-lg">
			<label for="dateFin" class="form-label fw-bold"
				>Actions envisagées :</label
			>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let module of listModuleEnum | keyvalue"
				>
					<div>
						<input
							type="checkbox"
							name="{{ module.value }}"
							class="form-check-input"
							[disabled]="isModuleDisabled(module.key)"
							[value]="module.key"
							[checked]="isModuleCheck(module.key)"
							[ngClass]="{
								'theme-main-color-check': isModuleCheck(module.key)
							}"
							(change)="updateSelectedModule($event, module.key)"
							[disabled]="isModuleDisabled(module.key)"
						/>
						<label class="ms-2 form-check-label text-dark">
							{{ PrestationTypeStringEnum[module.value] }}
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="this.isDSBSelected || this.isOSSelected || this.isDASelected || this.isBOSelected" class="row my-4">
		<div *ngIf="form.contains('argumentaire')" class="col-12 col-lg">
			<label for="argumentaire" class="form-label fw-bold"
				>Argumentaire</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorArgumentaire"> </ngx-editor-menu>
				<ngx-editor [editor]="editorArgumentaire" formControlName="argumentaire"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
